import { defineStore } from 'pinia';
import { ref } from 'vue';

import { IClass, IClassWithLabels, IClasses } from '@pssa/types';

import { xhr } from '@/helpers/service.ts';

export const useClassStore = defineStore('class', () => {
  const classes = ref<IClassWithLabels[]>([]);

  async function getClasses() {
    if (classes.value.length === 0) {
      const response: IClasses = await xhr('/class');

      if (response) {
        classes.value = response
          .map((c) => ({
            ...c,
            value: c._id,
            label: c.type,
          }))
          .reverse();
      }
    }
  }

  async function createClass(name: string) {
    const response: IClass = await xhr('/class', {
      method: 'post',
      body: { name },
    });

    classes.value.push({
      ...response,
      value: response._id,
      label: name,
    });

    return response;
  }

  function findClass(id: string) {
    return classes.value.find((className) => className._id === id);
  }

  return {
    classes,
    createClass,
    findClass,
    getClasses,
  };
});
